import { CONFIGURATION, CONFIGURATIONS, SIGNAL_EVENTS } from '@mm/api-routes';
import {
  SignalEventsResponse,
  SourceConfiguration,
} from '@mm/state/model/SignalModel';
import AuthenticatedController from './AuthenticatedController';

export default class SignalSourceConfigurationController extends AuthenticatedController {
  static async fetch(facebookPageId: number) {
    return super.get(CONFIGURATIONS(facebookPageId));
  }

  static async update(
    data: Partial<SourceConfiguration> & { id: number },
  ): Promise<SourceConfiguration> {
    return super.put(CONFIGURATION(data.id), data);
  }

  static async getEvents({
    facebookPageId,
    force = false,
    range,
    contactOrigin,
  }: {
    facebookPageId: number;
    force?: boolean;
    range?: 'week' | 'month' | '3 months';
    contactOrigin?: 'Existing' | 'New' | null;
  }): Promise<SignalEventsResponse> {
    return super.get(SIGNAL_EVENTS, {
      facebook_page_id: facebookPageId,
      force,
      ...(range ? { range } : {}),
      ...(contactOrigin !== undefined && contactOrigin !== null
        ? { contact_origin: contactOrigin }
        : {}),
    });
  }
}
